module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG0007-10fdf03a25f2c14a68fafc6bb28fb7ee.png";